"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
Object.defineProperty(exports, "__esModule", { value: true });
var Types_1 = require("../../../../../Types");
var React = require("react");
var reactstrap_1 = require("reactstrap");
var AuthenticationService_1 = require("../../../../../Services/AuthenticationService");
var Util_1 = require("../../../../../Services/Util");
var Components_1 = require("../../../../../Components");
var react_fontawesome_1 = require("@fortawesome/react-fontawesome");
var free_solid_svg_icons_1 = require("@fortawesome/free-solid-svg-icons");
var EventHandlerService_1 = require("../../../../../Services/EventHandlerService");
function TransferSuperUserEvent(updateCallback, admins, resources) {
    var _this = this;
    var superUserId = AuthenticationService_1.Auth.getUser().id;
    //item ref
    var transferSuperUserEventContentRef = React.createRef();
    //content
    var content = React.createElement(TransferSuperUserEventContent, { ref: transferSuperUserEventContentRef, updateCallback: updateCallback, admins: admins, resources: resources, superUserId: superUserId });
    //actions
    var actions = admins.some(function (u) { return u.id != superUserId; }) ? [
        new Types_1.VeriLiteEventAction(resources.Save, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
            var _a, _b;
            return __generator(this, function (_c) {
                (_b = (_a = transferSuperUserEventContentRef) === null || _a === void 0 ? void 0 : _a.current) === null || _b === void 0 ? void 0 : _b.transferSuperUser();
                return [2 /*return*/];
            });
        }); }, true),
        new Types_1.VeriLiteEventAction(resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
            closeModalCallback();
        })
    ] :
        [
            new Types_1.VeriLiteEventAction(resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                closeModalCallback();
            })
        ];
    //title
    var title = resources.TransferSuperUser;
    return new Types_1.VeriLiteInformationEvent(content, title, actions);
}
exports.TransferSuperUserEvent = TransferSuperUserEvent;
var InputValidationState;
(function (InputValidationState) {
    InputValidationState[InputValidationState["unset"] = 0] = "unset";
    InputValidationState[InputValidationState["invalid"] = 1] = "invalid";
    InputValidationState[InputValidationState["valid"] = 2] = "valid";
})(InputValidationState || (InputValidationState = {}));
var TransferSuperUserEventContentState;
(function (TransferSuperUserEventContentState) {
    TransferSuperUserEventContentState[TransferSuperUserEventContentState["Initial"] = 0] = "Initial";
    TransferSuperUserEventContentState[TransferSuperUserEventContentState["Pending"] = 1] = "Pending";
    TransferSuperUserEventContentState[TransferSuperUserEventContentState["Success"] = 2] = "Success";
    TransferSuperUserEventContentState[TransferSuperUserEventContentState["Error"] = 3] = "Error";
    TransferSuperUserEventContentState[TransferSuperUserEventContentState["NoAdmins"] = 4] = "NoAdmins";
})(TransferSuperUserEventContentState || (TransferSuperUserEventContentState = {}));
var TransferSuperUserEventContent = /** @class */ (function (_super) {
    __extends(TransferSuperUserEventContent, _super);
    function TransferSuperUserEventContent(props) {
        var _this = _super.call(this, props) || this;
        _this.error = {};
        _this.isInvalid = function (input) {
            return input === InputValidationState.invalid;
        };
        _this.updateValidation = function (validationResponse) {
            _this.setState({ ApplicationValidation: { Error: validationResponse, State: InputValidationState.invalid } });
        };
        _this.transferSuperUser = function () { return __awaiter(_this, void 0, void 0, function () {
            var options, json, userRequestHeaders, headers;
            var _this = this;
            var _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        this.updateModal(TransferSuperUserEventContentState.Pending);
                        options = {};
                        options = Object.assign(__assign({}, Util_1.defaultPostOptions), options);
                        json = JSON.stringify({ id: this.state.selectedUserId, email: (_a = this.props.admins.find(function (u) { return u.id == _this.state.selectedUserId; })) === null || _a === void 0 ? void 0 : _a.email });
                        options = __assign(__assign({}, options), { body: json });
                        userRequestHeaders = new Util_1.UserRequestHeaders(AuthenticationService_1.Auth.getUser());
                        headers = new Headers(options.headers);
                        return [4 /*yield*/, AuthenticationService_1.Auth.getAccessToken().then(function (token) {
                                headers.append("Authorization", "Bearer " + token);
                                options.headers = headers;
                            }).catch(function (error) {
                                console.error("Error adding auth header: " + error);
                            })];
                    case 1:
                        _b.sent();
                        userRequestHeaders.AppendHeaders(options);
                        fetch("/users/TransferSuperUser", options).then(function (response) {
                            if (!response.ok) {
                                switch (response.status) {
                                    case 400:
                                        _this.updateModal(TransferSuperUserEventContentState.Initial);
                                        response.json().then(function (validationResponse) {
                                            _this.updateValidation(validationResponse);
                                        });
                                        break;
                                    case 402:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(TransferSuperUserEventContentState.Error);
                                        });
                                        break;
                                    case 500:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(TransferSuperUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.ServerErrorMessage;
                                            _this.updateModal(TransferSuperUserEventContentState.Error);
                                        });
                                        break;
                                    default:
                                        response.json().then(function (errorResponse) {
                                            _this.error.title = errorResponse.title;
                                            _this.error.detail = errorResponse.detail;
                                            _this.updateModal(TransferSuperUserEventContentState.Error);
                                        }).catch(function () {
                                            _this.error.title = _this.props.resources.Error;
                                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                                            _this.updateModal(TransferSuperUserEventContentState.Error);
                                        });
                                        break;
                                }
                            }
                            else {
                                _this.updateModal(TransferSuperUserEventContentState.Success);
                            }
                        }).catch(function (err) {
                            _this.error.title = _this.props.resources.Error;
                            _this.error.detail = _this.props.resources.UnknownErrorMessage;
                            _this.updateModal(TransferSuperUserEventContentState.Error);
                            console.error("Error updating user:");
                            console.error(err);
                        });
                        return [2 /*return*/];
                }
            });
        }); };
        _this.updateModal = function (newState) {
            _this.setState({ status: newState });
            switch (newState) {
                case TransferSuperUserEventContentState.Success:
                    _this.props.updateCallback();
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.Success;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Finish, "primary", function (_currentEvent, closeModalCallback) { window.location.reload(); closeModalCallback(); })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case TransferSuperUserEventContentState.Error:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.error.title || _this.props.resources.Error;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case TransferSuperUserEventContentState.Pending:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.LoadingDotDotDot;
                    event.actions = [];
                    eventHandler.UpdateEvent();
                    break;
                case TransferSuperUserEventContentState.Initial:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.TransferSuperUser;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Save, "primary", function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_a) {
                                this.transferSuperUser();
                                return [2 /*return*/];
                            });
                        }); }),
                        new Types_1.VeriLiteEventAction(_this.props.resources.Cancel, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
                case TransferSuperUserEventContentState.NoAdmins:
                    var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                    var event = eventHandler.GetEvent();
                    event.title = _this.props.resources.TransferSuperUser;
                    event.actions = [
                        new Types_1.VeriLiteEventAction(_this.props.resources.Close, "secondary", function (currentEvent, closeModalCallback) {
                            closeModalCallback();
                        })
                    ];
                    eventHandler.UpdateEvent();
                    break;
            }
        };
        _this.onChange = function (event) {
            var _a;
            _this.setState({ selectedUserId: (_a = event.target) === null || _a === void 0 ? void 0 : _a.value }, function () {
                var eventHandler = EventHandlerService_1.EventHandlerProvider.GetInstance();
                var event = eventHandler.GetEvent();
                //Assuming the save button is action 0
                if (event.actions[0].isDisabled != !_this.state.selectedUserId) {
                    event.actions[0].isDisabled = !_this.state.selectedUserId;
                    eventHandler.UpdateEvent();
                }
            });
        };
        _this.stateBasedRender = function (currentState) {
            var _a;
            console.log(_this.props.admins.filter(function (u) { return u.id != AuthenticationService_1.Auth.getUser().id; }));
            switch (currentState) {
                case TransferSuperUserEventContentState.Initial:
                    return (React.createElement("div", null,
                        React.createElement("span", null, _this.props.resources.TransferSuperUserMessage),
                        React.createElement(reactstrap_1.InputGroup, { className: "my-3" },
                            React.createElement(reactstrap_1.InputGroupAddon, { addonType: "prepend" },
                                React.createElement(reactstrap_1.InputGroupText, null, _this.props.resources.User)),
                            React.createElement(reactstrap_1.Input, { type: "select", onChange: _this.onChange, value: _this.state.selectedUserId },
                                React.createElement("option", { key: "default", hidden: true }, _this.props.resources.PleaseSelectAUser),
                                "                            ",
                                _this.props.admins.filter(function (u) { return u.id != AuthenticationService_1.Auth.getUser().id; }).map(function (user) {
                                    return React.createElement("option", { key: user.id, value: user.id }, user.displayName);
                                }))),
                        _this.isInvalid(_this.state.ApplicationValidation.State) && React.createElement(reactstrap_1.FormFeedback, { style: { display: "block" } }, _this.state.ApplicationValidation.Error)));
                case TransferSuperUserEventContentState.Pending:
                    return (React.createElement(Components_1.CustomSpinner, null));
                case TransferSuperUserEventContentState.Success:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-success mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faCheckCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, ((_a = _this.props.admins.find(function (u) { return u.id == _this.state.selectedUserId; })) === null || _a === void 0 ? void 0 : _a.displayName) + " " + _this.props.resources.TransferSuperUserSuccessMessage),
                            React.createElement(reactstrap_1.Col, null))));
                case TransferSuperUserEventContentState.Error:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, { className: "text-danger mb-2" },
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" },
                                React.createElement(react_fontawesome_1.FontAwesomeIcon, { size: "6x", icon: free_solid_svg_icons_1.faTimesCircle })),
                            React.createElement(reactstrap_1.Col, null)),
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.error.detail || _this.props.resources.AnErrorHasOccurred),
                            React.createElement(reactstrap_1.Col, null))));
                case TransferSuperUserEventContentState.NoAdmins:
                    return (React.createElement("div", null,
                        React.createElement(reactstrap_1.Row, null,
                            React.createElement(reactstrap_1.Col, null),
                            React.createElement(reactstrap_1.Col, { xs: "auto" }, _this.props.resources.AdminsRequired),
                            React.createElement(reactstrap_1.Col, null))));
            }
        };
        _this.state = {
            status: props.admins.some(function (u) { return u.id != props.superUserId; }) ? TransferSuperUserEventContentState.Initial : TransferSuperUserEventContentState.NoAdmins,
            ApplicationValidation: { Error: "", State: InputValidationState.unset },
            selectedUserId: ""
        };
        return _this;
    }
    TransferSuperUserEventContent.prototype.render = function () {
        return this.stateBasedRender(this.state.status);
    };
    return TransferSuperUserEventContent;
}(React.Component));
//# sourceMappingURL=TransferSuperUserEvent.js.map